import { IFormInputControl } from '@infotech-soe/metaschema';

import { InputHistoryViewModel } from '../../../view-model/FormControlViewModel';
import { FormSource } from '../../../view-model/FormSource';

export const getControlValueHistory = (
  formSource: FormSource,
  name: IFormInputControl['name']
): InputHistoryViewModel => {
  const { formConfig }: Record<string, any> = formSource;
  return formConfig?.[name]?.history ?? [];
};
